import config from "../apis/config.js"
import {fileIcon} from '../util/fileIcon.js';
export default {
	data() {
		return {
			webImg: 'https://qimiyun.oss-cn-hangzhou.aliyuncs.com/', //网络图片前缀
			_lastTime: null, //上次点击时间
			isOffLine: false, //是否断网了
			time: {
				hour: "",
				minitus: "",
				seconds: ""
			},
			nowTime: "",
			week: [
				"星期天",
				"星期一",
				"星期二",
				"星期三",
				"星期四",
				"星期五",
				"星期六"
			],
		};
	},
	mounted() {
		// this.dateTime()
	},
	destroyed() {
		
	},
	methods: {
		preprocessLaTeX(content) {
    // 如果内容中已经有 $ 符号，说明已经是数学公式，直接返回，避免重复处理
    if (/\$/.test(content)) {
        return content;
    }

    // 保护代码块
    const codeBlocks = [];
    content = content.replace(/(```[\s\S]*?```|`[^`\n]+`)/g, (match) => {
        codeBlocks.push(match);
        return `<<CODE_BLOCK_${codeBlocks.length - 1}>>`;
    });

    // 自动将 align* 转成 aligned 并用 \[...\] 包裹
    content = content.replace(/\\begin\{align\*\}([\s\S]*?)\\end\{align\*\}/g, (match, inner) => {
        return `\\[\\begin{aligned}${inner}\\end{aligned}\\]`;
    });

    // 保护 LaTeX 表达式，新增 aligned 环境支持
    const latexExpressions = [];
    const latexPattern = /(\$\$[\s\S]*?\$\$|\\\[[\s\S]*?\\\]|\\\(.*?\\\)|\\begin\{aligned\}[\s\S]*?\\end\{aligned\})/g;
    content = content.replace(latexPattern, (match) => {
        latexExpressions.push(match);
        return `<<LATEX_${latexExpressions.length - 1}>>`;
    });

    // 转义数字前的 $
    content = content.replace(/\$(?=\d)/g, '\\$');

    // 恢复 LaTeX 占位符
    content = content.replace(/<<LATEX_(\d+)>>/g, (_, index) => latexExpressions[parseInt(index)]);

    // 恢复代码块占位符
    content = content.replace(/<<CODE_BLOCK_(\d+)>>/g, (_, index) => codeBlocks[parseInt(index)]);

    // 转换 \[...\] 和 \(...\)
    content = this.escapeBrackets(content);

    // 处理化学公式
    content = this.escapeMhchem(content);

    return content;
},
		// preprocessLaTeX(content) {
		// 	// 保护代码块
		// 	const codeBlocks = [];
		// 	content = content.replace(/(```[\s\S]*?```|`[^`\n]+`)/g, (match) => {
		// 		codeBlocks.push(match);
		// 		return `<<CODE_BLOCK_${codeBlocks.length - 1}>>`;
		// 	});

		// 	// 自动将 align* 转成 aligned 并用 \[...\] 包裹
		// 	content = content.replace(/\\begin\{align\*\}([\s\S]*?)\\end\{align\*\}/g, (match, inner) => {
		// 		return `\\[\\begin{aligned}${inner}\\end{aligned}\\]`;
		// 	});

		// 	// 保护 LaTeX 表达式，新增 aligned 环境支持
		// 	const latexExpressions = [];
		// 	const latexPattern = /(\$\$[\s\S]*?\$\$|\\\[[\s\S]*?\\\]|\\\(.*?\\\)|\\begin\{aligned\}[\s\S]*?\\end\{aligned\})/g;
		// 	content = content.replace(latexPattern, (match) => {
		// 		latexExpressions.push(match);
		// 		return `<<LATEX_${latexExpressions.length - 1}>>`;
		// 	});

		// 	// 转义数字前的 $
		// 	content = content.replace(/\$(?=\d)/g, '\\$');

		// 	// 恢复 LaTeX 占位符
		// 	content = content.replace(/<<LATEX_(\d+)>>/g, (_, index) => latexExpressions[parseInt(index)]);

		// 	// 恢复代码块占位符
		// 	content = content.replace(/<<CODE_BLOCK_(\d+)>>/g, (_, index) => codeBlocks[parseInt(index)]);

		// 	// 转换 \[...\] 和 \(...\)
		// 	content = this.escapeBrackets(content);

		// 	// 处理化学公式
		// 	content = this.escapeMhchem(content);

		// 	return content;
		// },
		escapeDollar(str) {
			return str.replace(/\$/g, '\\$');
		},
// escapeBrackets(text) {
//     const pattern = /(```[\s\S]*?```|`[^`\n]+`)|\\\[([\s\S]*?)\\\]|\\\(([\s\S]*?)\\\)/g;
//     return text.replace(pattern, (match, codeBlock, squareBracket, roundBracket) => {
//         if (codeBlock != null) {
//             return codeBlock;
//         } else if (squareBracket != null) {
//             const content = squareBracket.trim();
//             return `$$${content}$$`;
//         } else if (roundBracket != null) {
//             const content = this.escapeDollar(roundBracket.trim());
//             return `$${content}$`;
//         }
//         return match;
//     });
// },
        escapeBrackets(text) {
			const pattern = /(```[\s\S]*?```|`[^`\n]+`)|\\\[([\s\S]*?)\\\]|\\\(([\s\S]*?)\\\)/g;
			return text.replace(pattern, (match, codeBlock, squareBracket, roundBracket) => {
				if (codeBlock != null) {
					return codeBlock;
				} else if (squareBracket != null) {
					const content = squareBracket.trim();
					return `$$${content}$$`;
				} else if (roundBracket != null) {
					const content = this.escapeDollar(roundBracket.trim());
					return `$${content}$`;
				}
				return match;
			});
            // const pattern = /(```[\S\s]*?```|`.*?`)|\\\[([\S\s]*?[^\\])\\]|\\\((.*?)\\\)/g;
            // return text.replace(pattern, (match, codeBlock, squareBracket, roundBracket) => {
			// 	console.log(roundBracket,'roundBracket',squareBracket);
				
            //     if (codeBlock != null) {
            //         return codeBlock;
            //     } else if (squareBracket != null) {
            //         return `$$${squareBracket}$$`;
            //     } else if (roundBracket != null) {
			// 		//  return `\($${roundBracket}$\)`;
            //         return `$${roundBracket}$`;
			// 		//return `$\[${roundBracket}\]$`;
            //     }
            //     return match;
            // });
        },
        // 处理特殊的化学函数
        escapeMhchem(text) {
            return text.replaceAll('$\\ce{', '$\\\\ce{').replaceAll('$\\pu{', '$\\\\pu{');
        },
		settingFileIcon(resourceType, fileNameOrUrl){
			return fileIcon(resourceType, fileNameOrUrl)
		},
		//保存用户token
		saveToken(token) {
			this.$store.commit('changeToken', token);
			// uni.$emit('bindPush')
		},

		//保存用户信息
		saveUser(user) {
			this.$store.commit('changeUserInfo', user);
		},
		dateTime() {
			this.timeFormate();
			setTimeout(() => {
				this.dateTime();
			}, 1000);
		},
		timeFormate() {
			const newtime = new Date();
			this.time.hour = this.getIncrease(newtime.getHours(), 2);
			this.time.minitus = this.getIncrease(newtime.getMinutes(), 2);
			this.time.seconds = this.getIncrease(newtime.getSeconds(), 2);
			this.nowTime =
				this.getIncrease(newtime.getFullYear(), 4) +
				"年" +
				this.getIncrease(newtime.getMonth() + 1, 2) +
				"月" +
				this.getIncrease(newtime.getDate(), 2) +
				"日 " +
				this.week[newtime.getDay()];
			return `${this.time.hour}:${this.time.minitus}:${this.time.seconds}`;
		},
		getIncrease(num, digit) {
			var increase = "";
			for (var i = 0; i < digit; i++) {
				increase += "0";
			}
			return (increase + num).slice(-digit);
		},
		handleVisiable(e) {
			let isExist = e.target.visibilityState
			console.log(isExist)
			if (isExist === 'visible') {
				this.mathRdm()
				console.log(new Date().toLocaleString(), `您已进入页面！`)
			} else {
				clearInterval(this.timer)
				console.log(new Date().toLocaleString(), `您已离开页面！`)
			}
			switch (e.target.visibilityState) {
				case 'prerender':
					console.log('网页预渲染，内容不可见')
					break;
				case 'hidden':
					console.log('内容不可见，处理后台、最小化、锁屏状态')
					break;
				case 'visible':
					console.log('处于正常打开')
					break;
			}
		},
		mathRdm() {
			let num = 5000
			this.timer = setInterval(() => {

			}, num)
		},
		/**
		 * 数字字段值转换 规避toFixed 精度丢失问题
		 * @param {输入的数字 string、int 类型均可} n
		 * @param {保留位数 可输入 0} d
		 * @returns
		 */
		toFixedNum(n, d) {
			// 判断是小数
			var isFloat = parseInt(n) < parseFloat(n);

			if (typeof (d) == "undefined") {
				// 获取浮点型数值的小数位数
				d = (n != Math.floor(n)) ? (n.toString()).split('.')[1].length : 0;
			}

			if (isFloat) {
				n = Number(n);
				d = Number(d);
				n = n * Math.pow(10, d);
				n = Math.round(n);
				n = Number(n);
				n = n / Math.pow(10, d);
				n = n.toFixed(d);
				n = Number(n);
			} else {
				n = Number(n);
			}

			return n;
		},
		//数字转换为万单位
		formatNumber(num) {
			num = Number(num);
			if (num == 0) {
				return num + '';
			} else if (num > 1 && num < 10000) {
				return num + '';
			} else {
				return (num / 10000).toFixed(2);
			}
		},
		throttle(fn, gapTime) {
			if (gapTime == null || gapTime == undefined) {
				gapTime = 500 // 默认1000毫秒
			}
			let _nowTime = +new Date()
			if (_nowTime - this._lastTime > gapTime || !this._lastTime) {
				fn()
				// this.$message.success('刷新成功')
				this._lastTime = _nowTime
			}
		},
		getYear() {
			let date = new Date() // 如果date为13位不需要乘1000
			let Y = date.getFullYear()
			return Y
		},
		getDate(StringDate) {
			let date = new Date(StringDate) // 如果date为13位不需要乘1000
			let Y = date.getFullYear() + '-'
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
			let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
			let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
			let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return Y + M + D
		},
		getDateTime(StringDate) {
			let date = new Date(StringDate) // 如果date为13位不需要乘1000
			let Y = date.getFullYear() + '-'
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
			let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
			let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
			let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return Y + M + D
		},
		getDateTimes(StringDate) {
			let date = new Date(StringDate) // 如果date为13位不需要乘1000
			let Y = date.getFullYear() + '-'
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
			let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
			let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
			let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return Y + M + D + h + m
		},
		getDateTime1(StringDate) {
			let date = new Date(StringDate) // 如果date为13位不需要乘1000
			let Y = date.getFullYear() + '-'
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
			let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ' :'
			let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ' :'
			let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return h + " " + m + " " + s
		},
		getDateTime2(StringDate) {
			let date = new Date(StringDate) // 如果date为13位不需要乘1000
			let Y = date.getFullYear() + '-'
			let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
			let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ' : '
			let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ' : '
			let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return Y + M + D + h + m + s
		},
		//控制富文本图片大小
		formatRichText(html) {
			let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
				match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
				match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
				return match;
			});
			newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
				match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
				return match;
			});
			newContent = newContent.replace(/<br[^>]*\/>/gi, '');
			newContent = newContent.replace(/\<img/gi,
				'<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"');
			return newContent;
		},
	},
}
